/**
 * Sworn Translator — Wave 4 deep Q&A (document × embassy × intent).
 * Deterministic, price-free, self-contained answers for AI answer engines.
 */
import { SWORN_EMBASSIES, SWORN_DOC_TYPES } from "@/data/sworn";
import { expandDeep, deepAsOf, type DeepAxis } from "@/data/_qa/deep-expander";
import type { SwornQA } from "./questions-500";

const AS_OF = deepAsOf(
  "สิงหาคม 2569",
  "เงื่อนไขของสถานทูตและบัญชีนักแปลสาบานตนเปลี่ยนได้ ควรยืนยันกับสถานทูตปลายทางก่อนยื่นทุกครั้ง",
);

const INTENTS: DeepAxis[] = [
  { slug: "thai-spouse", th: "คู่สมรสไทยที่ยื่นเรื่องกับคู่สมรสต่างชาติ" },
  { slug: "student", th: "นักเรียนนักศึกษาที่จะไปเรียนต่อ" },
  { slug: "worker", th: "ผู้ที่จะไปทำงานต่างประเทศ" },
  { slug: "overseas", th: "ผู้ที่อยู่ต่างประเทศและส่งเอกสารจากไทย" },
  { slug: "company", th: "ฝ่ายบุคคลหรือบริษัทที่ยื่นแทนพนักงาน" },
];

export const SWORN_QA_WAVE4: SwornQA[] = expandDeep<SwornQA["cluster"]>({
  prefix: "sworn-w4",
  asOf: AS_OF,
  authorityTh: "สถานทูตปลายทาง",
  clusterTh: "งานแปลสาบานตน",
  primary: SWORN_DOC_TYPES.map((d) => ({ slug: d.slug, th: `แปลสาบานตน${d.nameTh}`, en: d.nameEn })),
  secondary: SWORN_EMBASSIES.map((e) => ({ slug: e.slug, th: e.nameTh, en: e.nameEn, note: `ภาษาที่ใช้คือ ${e.language} และมักใช้กับคำขอประเภท ${e.visaTypes.slice(0, 2).join(" / ")}` })),
  intents: INTENTS,
  clusters: { documents: "documents", process: "process", risk: "legal", location: "embassy" },
  cap: 520,
});
